<template>
  <el-card id="hotelItem" shadow="never" :body-style="{ padding: '0px', border: '1px solid #fff' }">
      <el-image class="hotelImage" :src="item.images[0].image"></el-image>
      <h3 style="font-size:18px;font-weight:400;text-align:left;">{{item.name}}</h3>
      <div style="font-size:15px;padding:5px 0px;"><i class="el-icon-phone"></i><a :href="tel">{{item.contact_number}}</a></div>
      <div style="font-size:15px;padding:5px 0px;"><i class="el-icon-message"></i><a :href="mailTo">{{item.email}}</a></div>
      <div style="font-size:13px;"><i class="el-icon-location"></i>{{item.address}}</div>
      <div style="font-size:15px;padding:5px 0px;"><i class="el-icon-time"></i> validity: {{item.validity}}</div>
      <div><el-button @click="out_link_click">Out link</el-button></div>
  </el-card>
</template>

<script>
export default {
    name: 'hotelItem',
    props: ['item'],
    computed: {
        tel() {
            return 'tel:' + this.item.contact_number
        },
        mailTo() {
            return 'mailto:' + this.item.email
        }
    },
    methods: {
        out_link_click(){
            window.location.href = 'js://redirect?url=https%3A%2F%2Fwww.baidu.com'
        }
    }
}
</script>

<style scoped>
#hotelItem{
    background-color: #fff;
    border: 1px solid #fff !important;
    text-align: left;
}
.hotelImage{
    position:inherit !important;
    width: 100%;
    max-height: 168px;
}
</style>